import { Product, ProductVariant } from '@/types/Product';

const findProductVariant = (
  product: Product,
  sku: string | undefined,
): ProductVariant | undefined => {
  return (
    product?.variants?.find((variant) => variant?.skuCode === sku) ?? undefined
  );
};

export default findProductVariant;
